import React, { useState ,useEffect } from 'react';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import {Step2Schema} from './schemas';
import Grid from '@material-ui/core/Grid';
import SelectField from '../../components/FormFields/SelectField';
import InputField from '../../components/FormFields/InputField';
import { makeStyles } from '@material-ui/core/styles';
import {Button,CardActions }  from '@material-ui/core';
import { nomenclatureService } from 'src/_services';
import axiosInstance from '../../axios-orders';
import { forEach } from 'lodash';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

const useStyles = makeStyles((theme) => ({
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
}));

const modalidad=[
  {
    value: 'PRESENTIAL',
    label: 'Presencial'
  },
  {
    value: 'SEMI_PRESENTIAL',
    label: 'Semipresencial'
  },
  {
    value: 'DISTANCE',
    label: 'A Distancia'
  }, 
];

export const Step2 = ({submit, setData, data}) => {  
  const [customers,setCustomers] = useState([]);
  const [areas,setAreas] = useState([]);
  useEffect(() => {
     let  token  = JSON.parse(localStorage.getItem('user'));
     
     axiosInstance().get('api/nomenclator/country/countries').then(res => {
         const customers = res.data;         
         const listItems = [];
         customers.forEach(customer => {
            listItems.push({
                'value': customer.id,
                'label': customer.country
            });
         });         
         console.log(listItems);
        setCustomers(listItems);       
       }).catch(console.error());
       
       axiosInstance().get('/api/nomenclator/scienceSpeciality/scienceSpecialities').then(res => {
        const areas_c = res.data;              
        const listItems1 = [];
        areas_c.forEach(customer => {
           listItems1.push({
               'value': customer.scieceSpeciality,
               'label': customer.scieceSpeciality
           });
        });        
        
        setAreas(listItems1);       
      }).catch(console.error())
 }, []); 
    const classes = useStyles();
   

  return (
    <Formik
      initialValues={data}      
      validationSchema={Step2Schema}
      onSubmit={(values) => {
        submit(2)
        setData({...values, ...data})
      }}
    >
      <Form>
      <Grid container spacing={3}>
      
      <Grid item xs={12} sm={6}>
        <InputField
          required
          id='thesisTitle'
          name='thesisTitle'
          label='Título de la Tesis'
          fullWidth   
          variant="outlined"         
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputField  required id='masterTitle' name='masterTitle' label='Título del master' fullWidth  variant="outlined" />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputField required id='institutionId' name='institutionId' label='Institucion' fullWidth  variant="outlined"/>
      </Grid>         
      <Grid item xs={12} sm={6}>
        <SelectField required  name='countryId' label='Pais donde cursó el master' data={customers} fullWidth  variant="outlined" />
      </Grid>
      <Grid item xs={12} sm={6}>
        <SelectField required name='scienceBranch' label='Área de Conocimientos' data={areas} fullWidth  variant="outlined" />
      </Grid>      
      <Grid item xs={12} sm={3}> 
      <SelectField
       required
        name='modality'
        label='Modalidad' 
        data={modalidad} 
        fullWidth 
         variant="outlined" />   
     
      </Grid> 
       <Grid item xs={12} sm={3}> 
      </Grid>
      <Grid item xs={12} sm={3}> 
      <InputField required  name='creditsCount' label='Cantidad de Creditos del Programa' fullWidth  variant="outlined" />
      </Grid>
      <Grid item xs={12} sm={3}> 
      <InputField required  name='programHours' label='Equivalencia en Horas' fullWidth  variant="outlined" />
      </Grid>
      <Grid item xs={12} sm={3}> 
      <InputField  name='completeTimeYears' label='Tiempo completo (años)' fullWidth  variant="outlined" />
      </Grid>
      <Grid item xs={12} sm={3}> 
      <InputField   name='partialTimeYears' label='Tiempo parcial (años)' fullWidth  variant="outlined" />
      </Grid>
      <Grid item xs={12} sm={3}> 
      <InputField   name='distanceTimeYears' label='Tiempo a distancia (años)' fullWidth  variant="outlined" />
      </Grid>
      <Grid item xs={12} sm={3}>
        <InputField required  name='defenseYear' label='Año de defensa' fullWidth  variant="outlined" />
      </Grid> 
      <Grid item xs={12} sm={2}>
        <InputField required name='tome' label='Tomo' fullWidth   variant="outlined"/>
      </Grid> 
      <Grid item xs={12} sm={2}>
        <InputField required name='folio' label='Folio' fullWidth  variant="outlined" />
      </Grid>
      <Grid item xs={12} sm={2}>
        <InputField required  name='number' label='Número' fullWidth  variant="outlined" />
      </Grid>     
    </Grid>
        <span>
        <Button
                    //disabled={isSubmitting}
                    type="button"
                    variant="contained"                    
                    color="default"
                    onClick={()=> {submit((e)=> e-1)}}
                    margin-left='1000px'
                   className={classes.button}
                  >     Anterior  
        </Button>
        <Button
                    //disabled={isSubmitting}
                    type="submit"
                    variant="contained"                    
                    color="primary"
                    //onClick={_handleSubmit}
                    className={classes.button}
                  >     Siguiente  
        </Button>
        </span>
        </Form>
    </Formik>
  );
};